"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TupleElementDefinition = exports.TupleElement = exports.Tuple = exports.Property = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var Property = /** @class */ (function (_super) {
    __extends(Property, _super);
    function Property(json) {
        var _this = _super.call(this, json) || this;
        _this.scope = json.scope;
        _this.source = (0, builder_1.build)(json.source);
        _this.path = json.path;
        return _this;
    }
    Property.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var obj, val, parts, curr_obj, _i, parts_1, part, _obj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        obj = this.scope != null ? ctx.get(this.scope) : this.source;
                        if (!(obj instanceof expression_1.Expression)) return [3 /*break*/, 2];
                        return [4 /*yield*/, obj.execute(ctx)];
                    case 1:
                        obj = _a.sent();
                        _a.label = 2;
                    case 2:
                        val = getPropertyFromObject(obj, this.path);
                        if (val == null) {
                            parts = this.path.split('.');
                            curr_obj = obj;
                            for (_i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
                                part = parts_1[_i];
                                _obj = getPropertyFromObject(curr_obj, part);
                                curr_obj = _obj instanceof Function ? _obj.call(curr_obj) : _obj;
                            }
                            val = curr_obj != null ? curr_obj : null; // convert undefined to null
                        }
                        if (val instanceof Function) {
                            return [2 /*return*/, val.call(obj)];
                        }
                        else {
                            return [2 /*return*/, val];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Property;
}(expression_1.Expression));
exports.Property = Property;
function getPropertyFromObject(obj, path) {
    var val;
    if (obj != null) {
        val = obj[path];
        if (val === undefined && typeof obj.get === 'function') {
            val = obj.get(path);
        }
    }
    return val;
}
var Tuple = /** @class */ (function (_super) {
    __extends(Tuple, _super);
    function Tuple(json) {
        var _this = _super.call(this, json) || this;
        var elements = json.element != null ? json.element : [];
        _this.elements = elements.map(function (el) {
            return {
                name: el.name,
                value: (0, builder_1.build)(el.value)
            };
        });
        return _this;
    }
    Object.defineProperty(Tuple.prototype, "isTuple", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Tuple.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var val, _i, _a, el, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        val = {};
                        _i = 0, _a = this.elements;
                        _e.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        el = _a[_i];
                        _b = val;
                        _c = el.name;
                        if (!(el.value != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, el.value.execute(ctx)];
                    case 2:
                        _d = _e.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _d = undefined;
                        _e.label = 4;
                    case 4:
                        _b[_c] = _d;
                        _e.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/, val];
                }
            });
        });
    };
    return Tuple;
}(expression_1.Expression));
exports.Tuple = Tuple;
var TupleElement = /** @class */ (function (_super) {
    __extends(TupleElement, _super);
    function TupleElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TupleElement;
}(expression_1.UnimplementedExpression));
exports.TupleElement = TupleElement;
var TupleElementDefinition = /** @class */ (function (_super) {
    __extends(TupleElementDefinition, _super);
    function TupleElementDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TupleElementDefinition;
}(expression_1.UnimplementedExpression));
exports.TupleElementDefinition = TupleElementDefinition;
//# sourceMappingURL=structured.js.map